import React from 'react';
import PropTypes from 'prop-types';
import { routerPush } from '@tcp/core/src/utils';
import { useRouter } from 'next/router';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  HEADER_LABELS,
  headerLabels,
  lblCreateAnAccount,
  lblHeaderLogin,
} from '@tcp/core/src/utils/labels/globalHeader.labels';
import styles, {
  Container,
  Paragraph,
  NonBoldText,
} from '../../styles/GuestFavoritesMessage.styles';
import Anchor from '../../../../../common/atoms/Anchor/views/Anchor';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblGuestFavLoginWishlistAddStyle,
} from '../../../../../../utils/labels/globalLogin.labels';

const GuestFavoritesMessage = ({ className }) => {
  const labels = getLabelFromCopyOrFromTranslation(HEADER_LABELS, headerLabels);
  const loginLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);
  const router = useRouter();

  const target = 'login';
  const pathname = router?.pathname || 'referrer';
  const successTarget = pathname;
  const href = `/home?target=${target}&successtarget=${successTarget}&fromGuestFav=true`;
  const asLogin = '/home/login';
  const asRegister = '/home/register';
  const query = {}; // Add any additional query parameters if needed
  const handleClick = (e, as) => {
    e.preventDefault();

    routerPush(href, as, query);
  };

  const createLink = (link, text) => {
    return (
      <Anchor
        noLink
        targetVal="_self"
        to={href}
        asPath={asLogin}
        className={'link-cls'}
        handleLinkClick={(e) => handleClick(e, link)}
      >
        {text}
      </Anchor>
    );
  };

  return (
    <Container>
      <Paragraph>
        <NonBoldText>
          <div className={`${className} body-wrapper`}>
            {createLink(asLogin, renderLabel(labels[lblHeaderLogin], lblHeaderLogin))}
            {' or '}
            {createLink(asRegister, renderLabel(labels[lblCreateAnAccount], lblCreateAnAccount))}
            {' to make'}
            <p>
              {renderLabel(
                loginLabels[lblGuestFavLoginWishlistAddStyle],
                lblGuestFavLoginWishlistAddStyle
              )}
            </p>
          </div>
        </NonBoldText>
      </Paragraph>
    </Container>
  );
};
GuestFavoritesMessage.propTypes = {
  className: PropTypes.string,
};

GuestFavoritesMessage.defaultProps = {
  className: '',
};

export default withStyles(GuestFavoritesMessage, styles);
